import { observer } from 'mobx-react-lite'
import { type SubmissionViewModel } from '@/features/jobs/drafting/SubmissionViewModel'
import { Pricing } from '@/features/jobs/drafting/components/JobCreation/Submission/Pricing'

export interface PricingContainerProps {
  vm: SubmissionViewModel
  boxed?: boolean
  compact?: boolean
}

export const PricingContainer = observer(function PricingContainer({
  vm,
  boxed,
  compact,
}: PricingContainerProps) {
  return <Pricing pricing={vm.pricing} boxed={boxed} compact={compact} />
})
